import { RadioChannelType } from "../../radio/data/RadioChannel";
import { InputData } from "../../../../library-js/php/input/InputData";

export class SongInput extends InputData
{
  id:string;
  channel:RadioChannelType;
}